import styled from 'styled-components'

export const TextWidth = styled.div.attrs({
  className: 'TextWidth',
})`
  // MOBILE
  grid-column: 1/-1;

  // MOBILE LANDSCAPE
  @media only screen and (min-width: 712px) {
    grid-column: 2 / span 6;
  }

  // DESKTOP
  @media only screen and (min-width: 1072px) {
    grid-column: 3 / span 8;
  }
  // DESKTOP LARGE
  @media only screen and (min-width: 1680px) {
    grid-column: 4 / span 6;
  }
`
export const TextWidthExtended = styled.div.attrs({
  className: 'TextWidthExtended',
})`
  // MOBILE
  grid-column: 1/-1;

  // MOBILE LANDSCAPE
  @media only screen and (min-width: 712px) {
    grid-column: 1 / span 8;
  }

  // DESKTOP
  @media only screen and (min-width: 1072px) {
    grid-column: 2 / span 10;
  }
  // DESKTOP LARGE
  @media only screen and (min-width: 1680px) {
    grid-column: 3 / span 8;
  }
`
export const Left = styled.div.attrs({
  className: 'Left',
})`

  // MOBILE
  grid-column: 1/-1;

  // MOBILE LANDSCAPE
  @media only screen and (min-width: 712px) {
    grid-column: 1 / span 4;
  }

  // DESKTOP
  @media only screen and (min-width: 1072px) {
    grid-column: 1 / span 6;
  }
  // DESKTOP LARGE
  @media only screen and (min-width: 1680px) {
    grid-column: 1 / span 6;
  }
`
export const LeftAndText = styled.div.attrs({
  className: 'LeftAndText',
})`
  // MOBILE
  grid-column: 2/-1;

  // MOBILE LANDSCAPE
  @media only screen and (min-width: 712px) {
    grid-column: 2 / span 6;
  }

  // DESKTOP
  @media only screen and (min-width: 1072px) {
    grid-column: 2 / span 9;
  }
  // DESKTOP LARGE
  @media only screen and (min-width: 1680px) {
    grid-column: 2 / span 8;
  }
`
export const RightAndText = styled.div.attrs({
  className: 'RightAndText',
})`
  // MOBILE
  grid-column: 1/-1;

  // MOBILE LANDSCAPE
  @media only screen and (min-width: 712px) {
    grid-column: 1 / span 4;
  }

  // DESKTOP
  @media only screen and (min-width: 1072px) {
    grid-column: 3 / span 10;
  }
  // DESKTOP LARGE
  @media only screen and (min-width: 1680px) {
    grid-column: 4 / span 9;
  }
`
export const Right = styled.div.attrs({
  className: 'Right',
})`
  // MOBILE
  grid-column: 1/-1;

  // MOBILE LANDSCAPE
  @media only screen and (min-width: 712px) {
    grid-column: 5 / span 4;
  }

  // DESKTOP
  @media only screen and (min-width: 1072px) {
    grid-column: 7 / span 6;
  }
  // DESKTOP LARGE
  @media only screen and (min-width: 1680px) {
    grid-column: 7 / span 6;
  }
`
export const ContentWidth = styled.div.attrs({
  className: 'ContentWidth',
})`
  grid-column: 1/-1;
`
